import React from "react";
import { Card, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";
import Header from "./header";
import Footer from "./footer";

export default function Frontend() {
  // Sample job openings data
  const frontendInternshipOpenings = [
    {
      title: "Frontend Development Intern",
      company: "TechInterns",
      location: "India, Remote",
      stipend: "₹2.4L - ₹5L per Annum",
      description:
        "TechInterns is offering an exciting Frontend Development Internship. As an intern, you'll work closely with our development team, gaining hands-on experience in building web applications. If you're a student passionate about frontend technologies, apply now and kickstart your career in web development.",
    },
    {
      title: "UI/UX Design Intern",
      company: "DesignInternHub",
      location: "India, Remote",
      stipend: "₹2.4L - ₹5L per Annum",
      description:
        "DesignInternHub is seeking a UI/UX Design Intern to join our creative team. This internship provides an opportunity to learn and contribute to the design of user interfaces for web applications. If you have a keen eye for design and want to explore the world of UI/UX, apply now!",
    },
    {
      title: "Frontend Engineering Intern",
      company: "CodeInterns",
      location: "India, Remote",
      stipend: "₹2.4L - ₹5L per Annum",
      description:
        "CodeInterns is expanding its internship program and looking for Frontend Engineering Interns. Join us to gain practical experience in building responsive and user-friendly web interfaces using cutting-edge technologies. If you're a motivated student eager to learn, we want to hear from you!",
    },
    {
      title: "React.js Intern",
      company: "ReactMinds",
      location: "India, Remote",
      stipend: "₹2.4L - ₹5L per Annum",
      description:
        "ReactMinds is offering an internship for React.js enthusiasts. Join our team to work on real-world projects and enhance your skills in building dynamic and interactive web applications. If you have a passion for React.js and frontend development, apply for this internship now!",
    },
    {
      title: "Web Design Intern",
      company: "PixelPerfection",
      location: "India, Remote",
      stipend: "₹2.4L - ₹5L per Annum",
      description:
        "PixelPerfection is looking for a Web Design Intern with a creative mindset. This internship provides hands-on experience in designing visually appealing and user-friendly web interfaces. If you're a design enthusiast, apply now and bring your creativity to our projects!",
    },
    {
      title: "Frontend Testing Intern",
      company: "TestInterns",
      location: "India, Remote",
      stipend: "₹2.4L - ₹5L per Annum",
      description:
        "TestInterns is hiring a Frontend Testing Intern to be part of our quality assurance team. Gain valuable experience in testing web applications and ensuring a seamless user experience. If you have a knack for finding and fixing bugs, apply for this internship now!",
    },
    {
      title: "Angular Intern",
      company: "AngularLearners",
      location: "India, Remote",
      stipend: "₹2.4L - ₹5L per Annum",
      description:
        "AngularLearners is looking for an intern with a passion for Angular development. Join us to learn and contribute to the development of scalable and efficient web applications. If you're excited about Angular and frontend technologies, apply now!",
    },
    {
      title: "Frontend Marketing Intern",
      company: "MarketingTechies",
      location: "India, Remote",
      stipend: "₹2.4L - ₹5L per Annum",
      description:
        "MarketingTechies is seeking a Frontend Marketing Intern to assist in creating visually appealing marketing materials. Gain experience in combining design and marketing strategies. If you're interested in the intersection of design and marketing, apply for this internship now!",
    },
    {
      title: "Vue.js Intern",
      company: "VueLovers",
      location: "India, Remote",
      stipend: "₹2.4L - ₹5L per Annum",
      description:
        "VueLovers is looking for an intern passionate about Vue.js. Join us to work on projects that leverage the power of Vue.js to create dynamic and responsive user interfaces. If you're eager to learn and contribute to Vue.js development, apply now!",
    },
    {
      title: "E-commerce Frontend Intern",
      company: "EcommerceInterns",
      location: "India, Remote",
      stipend: "₹2.4L - ₹5L per Annum",
      description:
        "EcommerceInterns is offering an internship for students interested in E-commerce frontend development. Gain practical experience in creating user-friendly interfaces for online shopping platforms. If you're excited about the intersection of frontend development and E-commerce, apply now!",
    },
    // Add 10 more internship openings
    {
      title: "Frontend Accessibility Intern",
      company: "AccessWebInterns",
      location: "India, Remote",
      stipend: "₹2.4L - ₹5L per Annum",
      description:
        "AccessWebInterns is dedicated to creating inclusive and accessible web experiences. We're hiring a Frontend Accessibility Intern to contribute to ensuring our applications are accessible to users of all abilities. If you're passionate about web accessibility, join us in making the web a more inclusive space.",
    },
    {
      title: "Frontend Performance Intern",
      company: "SpeedOptimizeInterns",
      location: "India, Remote",
      stipend: "₹2.4L - ₹5L per Annum",
      description:
        "SpeedOptimizeInterns is seeking a Frontend Performance Intern to optimize the speed and efficiency of our web applications. If you have a strong background in performance optimization techniques and a drive for creating lightning-fast user experiences, apply now and be a part of our high-performance team.",
    },
    {
      title: "Web Design Specialist Intern",
      company: "DesignCraftersInterns",
      location: "India, Remote",
      stipend: "₹2.4L - ₹5L per Annum",
      description:
        "DesignCraftersInterns is looking for a Web Design Specialist Intern with expertise in frontend technologies and a focus on creating visually appealing and user-friendly web interfaces. If you have a passion for design and a strong technical skill set, join us in shaping the visual identity of our products.",
    },
    {
      title: "Frontend Testing Engineer Intern",
      company: "TestMastersInterns",
      location: "India, Remote",
      stipend: "₹2.4L - ₹5L per Annum",
      description:
        "TestMastersInterns is hiring a Frontend Testing Engineer Intern to ensure the quality and reliability of our web applications. If you have experience in frontend testing frameworks and a keen eye for identifying and fixing bugs, join us in delivering flawless user experiences.",
    },
    {
      title: "Full Stack Developer Intern (Frontend Focus)",
      company: "FullStackGeniusInterns",
      location: "India, Remote",
      stipend: "₹2.4L - ₹5L per Annum",
      description:
        "FullStackGeniusInterns is looking for a Full Stack Developer Intern with a strong focus on frontend technologies. Join our versatile team and contribute to both frontend and backend development, creating end-to-end solutions for our clients. If you thrive in a dynamic environment, apply now!",
    },
    {
      title: "Frontend Mobile App Developer Intern",
      company: "MobileInnovateInterns",
      location: "India, Remote",
      stipend: "₹2.4L - ₹5L per Annum",
      description:
        "MobileInnovateInterns is expanding its team and seeking a Frontend Mobile App Developer Intern to create engaging and responsive mobile interfaces. If you have experience in mobile app development and a passion for crafting seamless user experiences, join us in shaping the future of mobile applications.",
    },
    {
      title: "Frontend E-commerce Developer Intern",
      company: "EcommerceTechInterns",
      location: "India, Remote",
      stipend: "₹2.4L - ₹5L per Annum",
      description:
        "EcommerceTechInterns is looking for a Frontend E-commerce Developer Intern to enhance the user experience of our online shopping platforms. If you have expertise in frontend technologies and a deep understanding of e-commerce best practices, join us in revolutionizing online shopping.",
    },
    {
      title: "Web Animation Specialist Intern",
      company: "AnimateWebInterns",
      location: "India, Remote",
      stipend: "₹2.4L - ₹5L per Annum",
      description:
        "AnimateWebInterns is hiring a Web Animation Specialist Intern to bring our web interfaces to life. If you have a passion for creating visually stunning animations and a strong foundation in frontend development, apply now and be a part of our creative and dynamic team.",
    },
    {
      title: "Frontend DevOps Engineer Intern",
      company: "DevOpsFrontInterns",
      location: "India, Remote",
      stipend: "₹2.4L - ₹5L per Annum",
      description:
        "DevOpsFrontInterns is seeking a Frontend DevOps Engineer Intern to optimize the deployment and maintenance of our frontend applications. If you have experience in DevOps practices and a focus on frontend infrastructure, join us in ensuring the reliability and scalability of our web solutions.",
    },
    {
      title: "Frontend Data Visualization Specialist Intern",
      company: "DataVizGeniusInterns",
      location: "India, Remote",
      stipend: "₹2.4L - ₹5L per Annum",
      description:
        "DataVizGeniusInterns is looking for a Frontend Data Visualization Specialist Intern to create compelling and informative data visualizations for our web applications. If you have a strong background in data visualization libraries and a passion for transforming data into insights, apply now!",
    },
    // Add 10 more internship openings
  ];

  return (
    <>
      <Helmet>
        <title>Front End Intern Web Developer Jobs 2025</title>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta
          name="description"
          content="Find remote frontend developer job opportunities with leading companies in 2025."
        />
        <meta
          name="keywords"
          content="frontend developer, remote jobs, web development, React, JavaScript"
        />
        <meta name="author" content="Your Name" />
        {/* Add more meta tags as needed */}
      </Helmet>
      <Header />
      <div className="container mt-4">
        <div className="row">
          <div className="col-md-12 mb-12 text-center">
            <h1 className="font-weight-bold">
              Frontend intern Developer Jobs 2025
            </h1>
            <p className="lead">
              Explore exciting remote opportunities in frontend intern
              development with leading companies.
            </p>
          </div>
          {frontendInternshipOpenings.map((job, index) => (
            <div key={index} className="col-md-12 mb-12">
              <Card>
                <Card.Body>
                  <Card.Title>{job.title}</Card.Title>
                  <Card.Text>{job.stipend}</Card.Text>
                  <Card.Subtitle className="mb-12 text-muted">
                    {job.company} - {job.location}
                  </Card.Subtitle>
                  <Card.Text>{job.description}</Card.Text>
                  <div className="d-flex justify-content-between align-items-center">
                    <Button variant="primary">Apply Now</Button>
                    <span>Today</span>
                  </div>
                </Card.Body>
              </Card>
              <br />
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
}
